<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 16.09.2020
  -- Description : Formulaire de création d'un fichier depuis la page d'une stage
  -- Fichier : CreateStageFile.vue
  -->

<template>
  <v-row justify="end">
    <v-form
      ref="formCreateContact"
      v-model="validCreateContact"
      lazy-validation
    >
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="success"
            dark
            v-bind="attrs"
            v-on="on"
            outlined
            fab
            x-small
            class="mx-3"
          >
            <v-icon>
              mdi-plus
            </v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Ajouter un fichier</span>
          </v-card-title>
          <v-card-text>
            <v-file-input label="Fichier" v-model="file" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Fermer
            </v-btn>
            <v-btn color="blue darken-1" text @click="submit()">
              Sauvegarder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-row>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'

export default {
  props: {
    stageId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    validCreateContact: true,
    dialog: false,
    file: null,
    stageFile: {
      stageId: 0,
      fileName: null,
      fileType: null,
      stageFileId: 0
    }
  }),

  methods: {
    // Si le formulaire est valide, création du fichier
    submit() {
      let formData = new FormData()
      formData.append('stageId', this.stageId)
      formData.append('file', this.file)

      if (this.$refs.formCreateContact.validate()) {
        NProgress.start()
        store
          .dispatch('stageFile/createStageFile', formData)
          .then(response => {
            this.stageFile.fileName = response.data.fileName
            this.stageFile.fileType = response.data.fileType
            this.stageFile.stageId = response.data.stageId
            this.stageFile.stageFileId = response.data.stageFileId
            let clone = JSON.parse(JSON.stringify(this.stageFile))
            this.addNewData(clone)
            this.file = null
            this.$refs.formCreateLastContact.reset()
          })
          .catch(() => {})
        this.dialog = false
        NProgress.done()
      }
    },
    // Ajoute le fichier à l'entreprise
    addNewData(data) {
      store
        .dispatch('stage/addStageFile', data)
        .then(() => {})
        .catch(() => {})
    }
  }
}
</script>
